module.exports = __webpack_public_path__ + "static/img/step3.1b0b8e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pages/task/step3.png
// module id = N+kM
// module chunks = 30